import { type DocNode } from '@atlaskit/adf-schema';
import { reduce } from '@atlaskit/adf-utils/traverse';
import type { ADFEntity } from '@atlaskit/adf-utils/types';

/**
 * Extracts plain text from an ADF document (used e.g. for comparing sent message to prompt card source).
 */
export const extractPlainTextFromAdf = (adf: DocNode): string =>
	reduce<string>(
		adf,
		(currentValue, node: ADFEntity) =>
			node.type === 'text' && node.text ? currentValue + node.text : currentValue,
		'',
	);
